import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { PATHS } from '../../../navigation/data';
import { getCustomerVatNumberForMyData } from '../../../services/utils/myDataUtils';
import { LinkTo } from '../../atoms/LinkTo';

interface Props {
  doc: InvoiceInterface;
}

export const DocViewCustomerData = ({ doc }: Props) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isPublicDoc = useMemo(() => pathname.includes(PATHS.SHARED_DOC), [pathname]);
  const getCustomerLink = useMemo(() => {
    if (isPublicDoc) return '';

    return `${PATHS.CUSTOMERS}/view/${doc?.customer?.id}`;
  }, [doc?.customer?.id, isPublicDoc]);

  // TODO: check max width and how we are going to handle bigger texts
  // We could wrap it probably
  return (
    <div className="flex-start-center-column-nowrap">
      <div className="flex-center-center-row-wrap">
        <div className="boldText1">{t('PDF.CUSTOMER_DATA')}</div>
      </div>
      <div className="flex-start-center-column-nowrap simpleBorder">
        <div className="container">
          <div className="flex-start-center-row-nowrap">
            <div className="boldText1 padding-r-12">{t('PDF.CUSTOMER_NAME')}:</div>
            <LinkTo link={getCustomerLink} data={{}} classes={'link-reset'}>
              <div className="normalText1 truncate-2lines text-blue">{doc?.customer?.companyName}</div>
            </LinkTo>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText1 padding-r-6">{t('PDF.CUSTOMER_PROFESSION')}:</div>
            <div className="normalText1 truncate-2lines">{doc?.customer?.profession}</div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="boldText1 padding-r-10">{t('PDF.ADDRESS')}:</div>
            <div className="normalText1 truncate-2lines">
              {doc?.customer?.address}, {doc.customer?.postalCode}
            </div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="flex-start-center-row-nowrap padding-r-8">
              <div className="boldText1 padding-r-6">{t('PDF.TOWN')}:</div>
              <div className="normalText1">{doc.customer.city}</div>
            </div>
            <div className="flex-start-center-row-nowrap">
              <div className="boldText1 padding-r-6">{t('PDF.PHONE_NUMBER_FULL')}:</div>
              <div className="normalText1">{doc.customer.phoneNumber}</div>
            </div>
          </div>
          <div className="flex-start-center-row-nowrap">
            <div className="flex-start-center-row-nowrap padding-r-6">
              <div className="boldText1 padding-r-6">{t('PDF.VAT_NUMBER')}:</div>
              <div className="normalText1">{getCustomerVatNumberForMyData(doc?.staticCustomer || doc?.customer)}</div>
            </div>
            <div className="flex-start-center-row-nowrap">
              <div className="boldText1 padding-r-6">{t('PDF.DOY')}:</div>
              <div className="normalText1">{doc?.customer?.doy?.name}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
